module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 1),
      expression: "status==1"
    }],
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("全国啦啦操活力校园参评")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '学校名称不能为空'
      }],
      "label": "学校名称",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入学校名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? (_vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county) : '',
      "input-align": "right",
      "label": "单位地区选择",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入学校详细地址'
      }],
      "label": "详细地址",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入学校详细地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入学校联系人姓名'
      }],
      "label": "联系人",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入学校联系人姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入学校联系人电话'
      }],
      "label": "联系人电话",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入学校联系人电话\t"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入全校学生总人数'
      }],
      "label": "全校学生总人数",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入全校学生总人数"
    },
    model: {
      value: (_vm.formData.member_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "member_count", $$v)
      },
      expression: "formData.member_count"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入参与啦啦操学生人数'
      }],
      "label": "参与啦啦操学生人数",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入参与啦啦操学生人数"
    },
    model: {
      value: (_vm.formData.sai_member_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sai_member_count", $$v)
      },
      expression: "formData.sai_member_count"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入占全校学生比例（%）'
      }],
      "label": "占全校学生比例（%）",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入占全校学生比例（%）"
    },
    model: {
      value: (_vm.formData.percent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "percent", $$v)
      },
      expression: "formData.percent"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入本次比赛参赛人数'
      }],
      "label": "本次比赛参赛人数",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入本次比赛参赛人数"
    },
    model: {
      value: (_vm.formData.thissai_member_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "thissai_member_count", $$v)
      },
      expression: "formData.thissai_member_count"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入已开展年数（年）'
      }],
      "label": "已开展年数（年）",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入已开展年数（年）"
    },
    model: {
      value: (_vm.formData.years),
      callback: function($$v) {
        _vm.$set(_vm.formData, "years", $$v)
      },
      expression: "formData.years"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入啦啦操教练人数'
      }],
      "label": "啦啦操教练人数",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入啦啦操教练人数"
    },
    model: {
      value: (_vm.formData.jiaolian_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jiaolian_count", $$v)
      },
      expression: "formData.jiaolian_count"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入每周开展次数'
      }],
      "label": "请输入每周开展次数",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入每周开展次数"
    },
    model: {
      value: (_vm.formData.week_times),
      callback: function($$v) {
        _vm.$set(_vm.formData, "week_times", $$v)
      },
      expression: "formData.week_times"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入每次开展时长（分钟）'
      }],
      "label": "每次开展时长（分钟）",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入每次开展时长（分钟）"
    },
    model: {
      value: (_vm.formData.minites),
      callback: function($$v) {
        _vm.$set(_vm.formData, "minites", $$v)
      },
      expression: "formData.minites"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [],
      "label": "学校在啦啦操推广方面的特色与创新",
      "maxlength": "500",
      "show-word-limit": "",
      "input-align": "right",
      "autosize": "",
      "type": "textarea",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "500字以内"
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "学校开展项目照片",
      "value": _vm.formData.pics.length + '/3'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pics,
      "limit": 3,
      "name": 'pics'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("请上传学校开展项目照片")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 2),
      expression: "status==2"
    }],
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.status = 1
      }
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.status = 3
      }
    }
  }, [_vm._v("上传盖章材料")])], 1)]), _vm._v(" "), _c('van-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status == 3),
      expression: "status==3"
    }],
    on: {
      "submit": _vm.onSubmit2,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("上传盖章材料")]), _vm._v(" "), _c('van-cell-group', [_c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.files,
      "limit": 1,
      "name": 'files'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left",
    staticStyle: {
      "color": "#1989fa"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("请点击这里先下载申报材料>>，然后上传盖章签字后的照片或扫描件")])]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "2rem"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "保存中..."
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.status = 1
      }
    }
  }, [_vm._v("返回修改")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-success"
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("提交成功")]), _vm._v(" "), _c('p', [_vm._v("请继续相关操作")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-124f557a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huoli/HuoliForm.vue
// module id = 2221
// module chunks = 0